module.exports = PermissionConsts = {
    PRODUCTION_LINE_MONITORIZATION_STRUCTURE_GET: "production-line-monitorization-structure.get",
    PRODUCTION_LINE_GET_ALL: "production-line.get-all",
    USER_INDEX_VIEW: "user-index.view",
    USER_PASSWORD_UPDATE: "user-password-update.update",
    USER_POST: "user.post",
    USER_ADMON_DELETE: "user.admon-delete",
    USER_ADMON_UPDATE: "user.admon-update",
    USER_UPDATE_PERMISSIONS: "user.update-permissions",
    USER_GET_PERMISSIONS: "user.get-permissions",
    USER_GET_ROLES_AND_PERMISSION_PACKAGES: "user.get-roles-and-permission-packages",
    PERMISSIONS_VUE_DATA_GET: "permissions-vue-data.get",
    PERMISSIONS_PACKAGE_ADMON_GET: "permissions-package.admon-get",
    PERMISSIONS_PACKAGE_ADMON_UPDATE: "permissions-package.admon-update",
    USERS_AND_PERMISSION_PACKAGES_GET: "users-and-permission-packages.get",
    USERS_AND_PERMISSION_PACKAGES_UPDATE: "users-and-permission-packages.update",
    ROLES_INDEX_VIEW: "role-index.view",
    ROLE_STORE: "role.store",
    ROLE_ADMON_DELETE: "role.admon-delete",
    ROLE_USER_UPDATE_ROLES: "user.update-roles",
    ROLE_LIST: "role.list",
    CALENDAR_WEEKDAY_GET_ALL: "weekday.get-all",
    CALENDAR_VIEW: "calendar.view",
    SHIFT_TEMPLATE_INDEX_VIEW: "shift-template-index.view",
    SHIFT_TEMPLATE_EDIT_VIEW: "shift-template-edit.view",
    SHIFTS_TEMPLATE_WITH_RELATION_NAMES_GET_ALL: "shifts-template-with-relation-names.get-all",
    SHIFTS_TEMPLATE_WITH_STOPS_TEMPLATES_GET: "shifts-template-with-stops-templates.get",
    SHIFTS_TEMPLATE_STORE: "shifts-template.store",
    SHIFTS_TEMPLATE_ADMON_UPDATE: "shifts-template.admon-update",
    SHIFTS_TEMPLATE_ADMON_DELETE: "shifts-template.admon-delete",
    STOPS_TEMPLATE_STORE: "stops-template.store",
    STOPS_TEMPLATE_ADMON_UPDATE: "stops-template.admon-update",
    STOPS_TEMPLATE_ADMON_DELETE: "stops-template.admon-delete",
    SHIFTS_INDIVIDUAL_BY_DATE_GROUPED_BY_PL_GET: "shifts-individual-by-date-grouped-by-pl.get",
    SHIFTS_INDIVIDUAL_GET_ALL: "shifts-individual.get-all",
    SHIFTS_INDIVIDUAL_BY_DATE_INTERVAL_GENERATE: "shifts-individual-by-date-interval.generate",
    SHIFTS_INDIVIDUAL_BY_DATE_INTERVAL_BY_PL_GENERATE: "shifts-individual-by-date-interval-by-pl.generate",
    SHIFTS_INDIVIDUAL_EXTRA_SHIFT_GENERATE: "shifts-individual-extra-shift.generate",
    SHIFTS_INDIVIDUAL_UPDATE: "shifts-individual.update",
    SHIFTS_INDIVIDUAL_BY_DATE_INTERVAL_DELETE: "shifts-individual-by-date-interval.delete",
    SHIFTS_INDIVIDUAL_DELETE: "shifts-individual.delete",
    SHIFTS_INDIVIDUAL_AT_DATE_ALL_PL_DELETE: "shifts-individual-at-date-all-pl.delete",
    SHIFTS_INDIVIDUAL_AT_DATE_BY_PL_DELETE: "shifts-individual-at-date-by-pl.delete",
    STOPS_INDIVIDUAL_UPDATE: "stops-individual.update",
    STOPS_INDIVIDUAL_DELETE: "stops-individual.delete",
    OPERATOR_VIEW: "operator.view",
    OPERATOR_LIST: "operator.list",
    OPERATOR_STORE: "operator.store",
    OPERATOR_GET: "operator.get",
    OPERATOR_UPDATE: "operator.update",
    OPERATOR_DELETE: "operator.delete",
    OPERATOR_TITLE_VIEW: "operator-title.view",
    OPERATOR_TITLE_LIST: "operator-title.list",
    OPERATOR_TITLE_STORE: "operator-title.store",
    OPERATOR_TITLE_GET: "operator-title.get",
    OPERATOR_TITLE_UPDATE: "operator-title.update",
    OPERATOR_TITLE_DELETE: "operator-title.delete",
    OPERATOR_TITLE_COMBO: "operator-title.select",
    PRODUCTION_ORDER_INDEX_VIEW: "order-index.view",
    PRODUCTION_ORDER_REFERENCE_FILTER_DATA_GET: "order-reference-filter-data.get",
    PRODUCTION_MACHINE_CONTROL_VIEW: "machine-production-control.view",
    PRODUCTION_MACHINE_SELECTOR_VIEW: "machine-selector.view",
    PRODUCTION_MONITORIZATION_VIEW: "monitorization.view",
    PRODUCTION_MACHINE_PRODUCTION_CONTROL_DATA_GET: "machine-production-control-data.get",
    PRODUCTION_MONITORIZATION_MACHINE_DATA_GET: "monitorization-machine-data.get",
    PRODUCTION_ORDER_PRODUCTION_ORDERS_GET: "order-get-order-references.get",
    PLANNER_PRODUCTION_CONTROL_VIEW: "planner-production-control-view",
    PLANNER_QUEUE_ORDER_UPDATE: "planner-queue-order.update",
    PLANNER_KANBAN_DATA_GET: "planner-kanban-data.get",
    PLANNER_TIMELINE_UPDATE: "planner-timeline.update",
    PLANNER_PRODUCTION_LINE_QUEUE_DATA_GET: "planner-production-line-queue-data.get",
    PLANNER_ORDER_REFERENCE_COMPUTED_DATA_GET: "planner-order-reference-computed-data.get",
    PLANNER_ORDER_REFERENCE_SPLIT: "order-reference.split",
    PLANNER_ORDER_REFERENCE_MERGE: "order-reference.merge",
    PLANNER_ORDER_REFERENCE_PAUSE_UPDATE: "order-reference-pause.update",
    PLANNER_ORDER_REFERENCE_IS_PAUSE_POSSIBLE_GET: "order-reference-is-pause-possible.get",
    STOCK_ORDER_REFERENCE_DELETE: "order-reference.delete",
    PLANNER_PRODUCTION_LINE_PROGRESS_ORDER: "production-line.progress-order",
    HEADER_SHOW: "header.show",
    HEADER_ABOUT_VIEW: "header-about.view",
    HEADER_ABOUT_STATUS_DATA_GET: "header-status-data.get",
    PRODUCTION_LINE_OK_CHECK: "production-line.ok-check",
    PACKAGING_GET_ALL: "packaging.get-all",
    ORDER_REFERENCE_VIEW: "order-reference.view",
    PRODUCTION_LINE_COMBO: "production-line.combo",
    REFERENCE_COMBO: "reference.combo",
    CLIENT_COMBO: "client.combo",
    REPORTING_CONFECTION_VIEW: "reporting.confection.view",
    REPORTING_CONFECTION_GET_DATA_BY_DATE: "reporting.confection.get-data-by-date",
    REPORTING_CONFECTION_GET_FILTERS_DATA: "reporting.confection.get-filters-data",
    USER_SESSION_TOKEN_INDIVIDUAL_NULLER: "user_session_token_individual.nuller",
    USER_LIST: "user.list",
    MACHINE_EDIT_VIEW: "machine-edit.view",
    PRODUCTION_MACHINE_DATA_GET: "machine-production-data.get",
    MACHINE_GET_MACHINE_TYPES_GET: "machine-get-machine-types.get",
    MACHINE_STORE: "machine.store",
    MACHINE_ADMON_UPDATE: "machine-admon.update",
    MACHINE_TOPIC_STORE: "machine-topic.store",
    MACHINE_UPDATE_TOPICS: "machine-topics.update",
    ORDER_STOCK_ORDER_CREATE: "order.stock-order-create",
    ORDER_STOCK_ORDER_CREATE_FILTERS: "order.stock-order-create-filters",
    ADMIN_CONFIGURATIONS: "admin.configurations",
    REFERENCE_VIEW: "reference.view",
    REFERENCE_ICT_EDIT: "reference-ict.edit",
    MACHINE_VIEW: "machine.view",
    MACHINE_EFFICIENCY_PCT_EDIT: "machine-efficiency-pct.edit",
};
